"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
/**
 * Client interface to get a list of promo codes
 * @param {string} quoteId
 * @returns Promise
 */
const getPromoList = (quoteId) => {
    const requestId = 'PROMO_INFO';
    const rawEndPoint = ENDPOINTS_1.default.TARIFF_SERVICE.PROMO_LIST;
    const endPoint = rawEndPoint.replace('{quoteId}', quoteId);
    return http_service_1.default
        .get(requestId, endPoint)
        .then((response) => response.data)
        .catch((err) => {
        console.log('🚀 ~ error Promo List API:', err);
        return {};
    });
};
exports.default = getPromoList;
